<template>
  <div>
    <vs-card>
      <b-row>
        <b-col>
          <b-row>
            <b-col cols="3" align-self="center">
              <b-form-group
                style="font-size: small; font-weight: bold"
                :label="'Pazaryeri '"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                v-model="selectedMp"
                :options="tabList"
                label="name"
                name="marketplace"
                style=""
                v-validate="'required'"
              >
              </v-select>

              <span class="text-danger text-sm" v-show="errors.has('marketplace')">{{
                errors.first("marketplace")
              }}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <b-col cols="3" align-self="center">
              <b-form-group
                style="font-size: small; font-weight: bold"
                :label="'Sipariş Numaraları '"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                color="danger"
                v-model="selectedOrder"
                :options="barcodematch_options"
                size="small"
                autocomplete
                ref="selectElement"
                name="order"
                :taggable="true"
                multiple
                @input="focusSelect"
                v-validate="'required'"
              >
              </v-select>

              <span class="text-danger text-sm" v-show="errors.has('order')">{{
                errors.first("order")
              }}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="auto" style="padding-left: 0px !important">
          <vs-button
            @click="faturaSend()"
            id="button-with-loading"
            class="vs-con-loading__container"
            color="primary"
            style="border-radius: 5px; height: 40px"
            type="gradient"
            >Gönder</vs-button
          >
        </b-col>
      </b-row>
    </vs-card>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { Validator } from "vee-validate";
export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      selectedMp: "",
      selectedOrder: "",
      barcodematch_options: [],
    };
  },
  created() {
    this.tabList = this.$store.state.uzum.menuListForTabs;
    console.log(this.tabList);
  },
  methods: {
    focusSelect() {
      this.$nextTick(() => {
        const selectEl = this.$refs.selectElement.$el.querySelector("input");
        if (selectEl) {
          selectEl.focus(); // Focus on the input inside the v-select
        }
      });
    },
    faturaSend() {
      this.secilenFatura = [];
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = this.$store.state.sistemAddress;
      this.$validator.validateAll().then((result) => {
        if (result) {
          try {
            let selectedBarcodes = [];
            this.selectedOrder.forEach((val, index) => {
              console.log(val);
              if (this.selectedOrder.length - 1 == index) {
                console.log(index);
                selectedBarcodes += val;
              } else selectedBarcodes += val + ",";
            });

            const args = {
              program: this.selectedMp.name,
              orderNumbers: selectedBarcodes,
              token: this.$store.state.tokenId,
            };
            console.log(args);

            soap.createClient(url, function (err, client) {
              client.earsivTamamlananGonder(args, function (err, result) {
                if (result.earsivTamamlananGonderResult == "-1") {
                  Store.dispatch("logout");
                }

                vs.notify({
                  text: result,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              });
            });
          } catch (error) {
            vs.notify({
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          }
        } else {
          vs.notify({
            text: "Eksik alanları doldurun",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
  },
};
</script>
